import React from 'react'
import { useTenant } from '@emerald-works-nova/auth'
import { useGroup } from '../../../hooks'
import { CONSUMER, ADMIN } from '../../../services/cognito/userGroups'
import PaidConsumerPrimaryLayout from './paid'
import FreeConsumerPrimaryLayout from './free'

const ConsumerPrimaryLayout = () => {
  const tenant = useTenant()
  const isPaidConsumerHomepageOn = tenant.paidConsumerHomepage === true

  const { isInGroup } = useGroup()
  const shouldShowPaidLayout = isInGroup([CONSUMER, ADMIN]) && isPaidConsumerHomepageOn
  return shouldShowPaidLayout ? <PaidConsumerPrimaryLayout /> : <FreeConsumerPrimaryLayout />
}

export default ConsumerPrimaryLayout
